import styled from 'styled-components';

export const YearlyThresholdsContainerStyle = styled.div`
  .download-action-buttons {
    margin-top: -2%
  }
`;
